import { useQuery } from 'react-query';
import getOpenJobs from '../../functions/getOpenJobs';
import { QUERY_OPEN_JOBS } from '../../assets/constants/queryConstants';

const useOpenJobs = () => {
  return useQuery([QUERY_OPEN_JOBS], () => getOpenJobs());
};

export default useOpenJobs;
